/** The periods Agency › Overview offers, in days up to today, and the one it opens on. */
export const AGENCY_OVERVIEW_PERIOD_DAYS = [7, 30, 90] as const;
export type AgencyOverviewPeriodDays = (typeof AGENCY_OVERVIEW_PERIOD_DAYS)[number];
export const AGENCY_OVERVIEW_DEFAULT_DAYS: AgencyOverviewPeriodDays = 30;
